import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { titleCase } from "../../utils/case";
import { LANGS } from "../../utils/pageHelpers";
import { hasRole } from "../../utils/auth";

const Simple = ({ content, fields, updateLangField }) => {
  const { t } = useTranslation();
  const canManage = hasRole(
    "superadmin",
    "finance"
  );

  return (
    <>
      {fields.map((field) => (
        <Card className="mb-4" key={field.key}>
          <CardBody>
            <h6>{titleCase(t(field.label))}</h6>

            <Row>
              {LANGS.map((lang) => (
                <Col md="4" key={lang}>
                  <FormGroup>
                    <Label>{lang.toUpperCase()}</Label>
                    <Input
                      type={field.type || "text"}
                      rows={field.type === "textarea" ? 4 : undefined}
                      value={content[field.key]?.[lang] || ""}
                      onChange={(e) =>
                        updateLangField(field.key, lang, e.target.value)
                      }
                      disabled={!canManage}
                    />
                  </FormGroup>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      ))}
    </>
  );
};

export default Simple;